export default __webpack_public_path__ + "static/fopc-ecc5daf31fad1bb39b5e33a7911358cb.png";